<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "gauge",
  components: {
    VChart,
  },
  //背景颜色
  provide: {
    [THEME_KEY]: "",
  },
  props:{
    value:{
      type:Number
    }
  },
  data() {
    return {
      option: {
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            max:1000,
            min:0,
            progress: {
              show: true,
              width: 10,
            },
            axisLine: {
              lineStyle: {
                width: 10,
              },
            },
            axisTick: {
              show: true,
            },
            splitLine: {
              length: 1,
              lineStyle: {
                width: 2,
                color: "#999",
              },
            },
            pointer:{
              show:false
            },
            axisLabel: {
              show:false,
              distance: 25,
              color: "#999",
              fontSize: 10,
            },
            anchor: {
              show: false,
              showAbove: false,
              size: 25,
              itemStyle: {
                borderWidth: 10,
              },
            },
            title: {
              show: true,
              offsetCenter: [0, '0%'],
              fontSize: 10,
              color:'#fff'
            },
            detail: {
              valueAnimation: true,
              formatter: '{value}v',
              color:'#2d7596',
              fontSize: 20,
              offsetCenter: [0, "-20%"],
            },
            data: [
              {
                value: this.value,
                name: '实时电压'
              },
            ],
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0.5,
                x2: 0,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#5c7187", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#2278cc", // 100% 处的颜色
                  },
                ],
                global: false,
              },
            },
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.chart {
  width: 180px;
  height: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/annealing.vue